import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_STATISTIC_SAGA } from "../sagaTypes";
import { loaderAction, statisticAction, statisticDatesAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_statistic`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetStatistic(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);
    const statistic_dates = yield select(state => state.statistic_dates);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('date_from', args.data?.date_from || '');
        formData.append('date_to', args.data?.date_to || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сохраняем статистику
            yield put(statisticAction(response.statistic));
            // Если не установлены даты фильтров, применяем сегодняшнюю дату из ответа
            if (!statistic_dates.from && !statistic_dates.to) {
                yield put(statisticDatesAction({
                    from: response.statistic.date,
                    to: response.statistic.date
                }));
            }
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetStatistic() {
    yield takeLatest(GET_STATISTIC_SAGA, workerGetStatistic);
}